<template>
  <div class="md-layout">
    <div
      ref="clientContainer"
      class="md-layout-item md-size-100 client-container"
    >
      <transition name="bounce">
        <Client
          v-if="selectedClient"
          :client="selectedClient"
          @hideClient="hideClient"
          @saveClient="getClients"
        />
      </transition>
    </div>
    <SearchTable
      ref="table"
      :header="{
        title: 'Klijenti',
        icon: 'recent_actors',
        class: 'md-card-header-brand',
      }"
      :queriedData="clients"
      :metaData="metaData"
      :getItems="getClients"
      :params="params"
      :sortBy="'id'"
      :newItem="createClient"
      :templates="templates"
      :openItem="openClient"
      :forEachSelected="[
        {
          icon: 'delete',
          label: 'Briši',
          class: 'md-danger',
          function: deleteClients,
        },
      ]"
    />
  </div>
</template>

<script>
import SearchTable from '@/components/SearchTable.vue';
import services from '@/api/services';
import api from '@/api/api.js';
import Client from '@/components/Client.vue';
import Swal from 'sweetalert2';
import { cases } from '@/utils/helpers';

export default {
  components: {
    SearchTable,
    Client,
  },
  data() {
    return {
      params: {
        id: null,
        name: '',
        email: '',
        isClient: ['1', '0'],
        isSeller: ['1', '0'],
        type: ['store'],
      },
      clients: [],
      selectedClient: null,
      metaData: null,
      templates: [
        {
          name: 'Firme',
          params: {
            id: null,
            name: '',
            email: '',
            isClient: ['1', '0'],
            isSeller: ['1', '0'],
            type: ['store'],
          },
        },
        {
          name: 'Fizička lica',
          params: {
            id: null,
            name: '',
            email: '',
            isClient: ['1', '0'],
            isSeller: ['1', '0'],
            type: ['person'],
          },
        },
      ],
    };
  },
  methods: {
    getClients(printTable = false) {
      const offset = this.metaData ? this.$refs.table.from : 0;
      const limit = this.metaData ? this.$refs.table.pagination.perPage : 75;
      const sortBy = this.metaData ? this.$refs.table.currentSort : null;
      const sortOrder = this.metaData
        ? this.$refs.table.currentSortOrder
        : null;
      api
        .get(services.clients.getClients, {
          loadClients: true,
          params: this.params,
          offset,
          limit,
          sortBy,
          sortOrder,
          printTable,
        })
        .then((data) => {
          this.clients = data.data;
          this.metaData = data.metaData;
        })
        .then(() => {
          this.loaded = true;
        })
        .catch((error) => {
          this.alertError(error);
        });
    },
    openClient(value) {
      const id = value.id;
      this.$router.push({ path: 'clients', query: { id } });
      this.getClientParams();
    },
    getClientParams() {
      api
        .get(services.clients.getClientParams, {
          loadClient: true,
          clientId: this.$route.query.id,
        })
        .then((data) => {
          this.selectedClient = data;
        })
        .catch((error) => {
          this.alertError(error);
        });
      this.$smoothScroll({
        scrollTo: this.$refs.clientContainer,
        hash: '#sampleHash', // required if updateHistory is true
      });
    },
    deleteClients(items) {
      const ids = items.map((el) => el.id);
      return Swal.fire({
        title: 'Obriši klijente?',
        text: `Da li ste sigurni da želite da obrišete ${ids.length} ${cases(
          ids.length,
          'klijenta',
          'klijenta',
          'klijenata',
        )}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-danger btn-fill',
        cancelButtonClass: 'md-button btn-fill',
        confirmButtonText: 'Obriši!',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((data) => {
        if (data.value) {
          (() => {
            if (ids.length >= 5) {
              return Swal.fire({
                title: 'Obriši klijente?',
                text: `Označili ste ${ids.length} ${cases(
                  ids.length,
                  'klijenta',
                  'klijenta',
                  'klijenata',
                )} za brisanje. Potvrdite još jednom da želite da nastavite.`,
                type: 'warning',
                showCancelButton: true,
                cancelButtonClass: 'md-button btn-fill',
                confirmButtonClass: 'md-button md-danger btn-fill',
                confirmButtonText: 'Obriši!',
                cancelButtonText: 'Otkaži',
                buttonsStyling: false,
              });
            } else {
              return Promise.resolve(data);
            }
          })().then((data) => {
            if (data.value) {
              api
                .post(services.clients.deleteClients, {
                  deleteClients: true,
                  ids,
                })
                .then(() => {
                  this.getClients();
                  this.$refs.table.removeChecked();
                })
                .catch((error) => {
                  this.alertError(error);
                });
            }
          });
        }
      });
    },
    hideClient() {
      this.selectedClient = null;
    },
    createClient() {
      this.selectedClient = {
        id: null,
        name: null,
        type: 'store',
        address: null,
        city: 'Podgorica',
        country: 'MNE',
        website: null,
        email: null,
        pib: null,
        isClient: true,
        isSeller: false,
        pdvCode: null,
        contact1: null,
        contact2: null,
        contact3: null,
        contact4: null,
        bankAccount1: null,
        bankAccount2: null,
        comment: null,
        contactPersons: [],
      };
    },
    deleteClient(client) {
      Swal.fire({
        title: 'Da li ste sigurni?',
        text: `Izbrisi klijenta ${client.name}!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'md-button md-success',
        cancelButtonClass: 'md-button md-danger',
        confirmButtonText: 'Da, izbriši',
        cancelButtonText: 'Otkaži',
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          api
            .post(services.deleteClient, {
              deleteClient: true,
              clientId: client.id,
            })
            .then((data) => {
              if (!data.error) {
                Swal.fire({
                  title: 'Uspješno',
                  text: `Izbrisali ste klijenta ${client.name}`,
                  type: 'success',
                  confirmButtonClass: 'md-button md-success',
                  buttonsStyling: false,
                }).then(() => {
                  if (this.selectedClient.id === client.id)
                    this.selectedClient = null;
                  this.getClients();
                });
              }
            })
            .catch((error) => {
              this.alertError(error);
            });
        }
      });
    },
  },
  mounted() {
    this.getClients();
    if (this.$route.query && this.$route.query.id) this.getClientParams();
  },
  watch: {
    selectedClient(to) {
      if (to.name) {
        document.title = `${to.name} - ${this.$route.meta.title}  - WebToPrint`;
      }
    },
  },
};
</script>

<style scoped>
.cursor-on-hover {
  cursor: pointer;
}
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-out 0.5s;
}
@keyframes bounce-in {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(0);
  }
}
@keyframes bounce-out {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(100%);
  }
}
</style>
